import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import { memo, useMemo, useRef } from 'react';
import { jsx } from '@emotion/core';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
import { itemStyles, itemWrapperStyles } from '../internal/styles';
import Step from './internal/step';
import useOverflowable from './internal/use-overflowable';
var AKTooltip = lazyForPaint(function () {
  return import(
  /* webpackChunkName: "@atlaskit-internal_Tooltip" */
  '@atlaskit/tooltip');
}, {
  ssr: false
});
var BreadcrumbsItem = /*#__PURE__*/memo(function (props) {
  var buttonRef = useRef(null);

  var truncationWidth = props.truncationWidth,
      text = props.text,
      restButtonProps = _objectWithoutProperties(props, ["truncationWidth", "text"]);

  var showTooltip = useOverflowable(truncationWidth, buttonRef);

  var buttonProps = _objectSpread(_objectSpread({}, restButtonProps), {}, {
    ref: buttonRef,
    hasOverflow: showTooltip
  });

  var styles = useMemo(function () {
    return itemStyles(truncationWidth);
  }, [truncationWidth]);
  var step = jsx(Step, _extends({}, buttonProps, {
    css: styles
  }), text);
  return jsx("li", {
    css: itemWrapperStyles
  }, showTooltip ?
  /* The div exists because of tooltip */
  jsx(LazySuspense, {
    fallback: jsx("div", null, step)
  }, jsx(AKTooltip, {
    content: text,
    position: "bottom"
  }, step)) : step);
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc

export default BreadcrumbsItem;